<template>
  <div class="help-center-new">
    <div class="head">
      <span class="icon"></span>
      <span class="title">{{ categoryTreeData.title }}</span>
    </div>

    <div class="list-box list-box-1" v-for="item in categoryTreeData.children">
      <template v-if="(item.children && item.children.length) || (item.document && item.document.length)">
        <p class="list-title">{{ item.title }}</p>
        <template v-if="item.children && item.children.length">
          <div
            class="item"
            v-for="cItem in item.children"
            @click="toLevel3(item.id)">
            <p class="title">{{ cItem.title }}</p>
            <span class="arrow"></span>
          </div>
        </template>
        <template v-if="item.document && item.document.length">
          <div
            class="item"
            v-for="cItem in item.document"
            @click="toDetail(cItem.document_id)">
            <p class="title">{{ cItem.title }}</p>
            <span class="arrow"></span>
          </div>
        </template>
        <div class="line"></div>
      </template>
    </div>
    <div class="list-box" v-if="categoryTreeData.document && categoryTreeData.document.length">
      <p class="list-title">{{ $t('helpCenterNew.m00006') }}</p>
      <div
        class="item"
        v-for="item in categoryTreeData.document"
        @click="toDetail(item.document_id)">
        <p class="title">{{ item.title }}</p>
        <span class="arrow"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryTreeData: []
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getHelpCategoryTree()
  },
  methods: {
    getHelpCategoryTree(){
      this.$apis.getHelpCategoryTree({
        category_id: this.id,
        display: 'document'
      }).then(res => {
        if(res.tree){
          this.categoryTreeData = res.tree[0];
        }
      })
    },

    toLevel3(id){
      this.$router.push({
        path: `/help-center/level3`,
        query: {
          ...this.$route.query,
          id
        }
      })
    },

    toDetail(id){

      this.$router.push({
        path: `/help-center/details`,
        query: {
          ...this.$route.query,
          id
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.help-center-new{
  .head{
    margin: 14px 32px;
    height: 120px;
    background: url("../../assets/images/help-center-new/bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    .icon{
      margin: 0 8px 0 11px;
      width: 96px;
      height: 96px;
      background: url("../../assets/images/help-center-new/icon-level-1.png") no-repeat;
      background-size: 100% 100%;
    }
    .title{
      font-size: 36px;
      line-height: 36px;
      font-weight: 500;
    }
  }
  .list-box{
    padding: 0 32px;
    .list-title{
      line-height: 104px;
      font-size: 34px;
      font-weight: 600;
      position: relative;
      &:after{
        content: '';
        position: absolute;
        left: -50%;
        bottom: 0;
        width: 200%;
        height: 1px;
        background: #EBEBEB;
        transform: scale(0.5);
      }
    }
    
    .item{
      display: flex;
      align-items: center;
      line-height: 104px;
      position: relative;
      &:after{
        content: '';
        position: absolute;
        left: -50%;
        bottom: 0;
        width: 200%;
        height: 1px;
        background: #EBEBEB;
        transform: scale(0.5);
      }
      
      .title{
        flex: 1;
        font-size: 28px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .arrow{
        width: 32px;
        height: 32px;
        background: url("../../assets/images/help-center-new/arrow.png") no-repeat;
        background-size: 100% 100%;
      }

    }
    .line {
      background: #F9FAFC;
      height: 24px;
      margin-left: -32px;
      margin-right: -32px;
    }
    
  }
  .list-box-1 {
    .item {
      &:nth-last-child(2) {
        &::after{
          display: none;
        }
      }
    }
  }
}

</style>